import React from 'react';
import '../less/index';
import Breadcrumbs from '../../../../auxiliary-components/Breadcrumbs';
import {
    MAIN,
    SPECIAL_OFFERS,
    CONTACT_LESS
} from '../../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import {Link, Button, Control} from 'MWC';
import {LANG} from '../../../../services/l10n';

export default function template() {
    const links = [MAIN, SPECIAL_OFFERS, CONTACT_LESS];

    return (
        <div className='contact-less'>
            <Breadcrumbs links={links} {...this.props} />

            <div className='banner'>
                <div className='banner-content'>
                    <div className='block-logo'>
                        <div className='block-logo-mastercard'></div>
                        <div className='block-vertical-line'>|</div>
                        <div className='block-logo-a-bank'></div>
                    </div>
                    <div className='block-title'>
                        <p
                            className='block-title_text1'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_TITLE_TEXT')
                            }}
                        ></p>
                        <p
                            className='block-title_text2'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_TITLE_TEXT1')
                            }}
                        ></p>
                        <p
                            className='block-title_text2_mobile'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_TITLE_TEXT1_MOBILE')
                            }}
                        ></p>
                    </div>
                </div>
            </div>

            <div className='content'>
                <div className='conditions-block action'>
                    <p>{this.l10n('APLLE_SUMMER_CONDITIONS_TITLE')}</p>

                    <div className='conditions-action'>
                        <div className='conditions-action-one'>
                            <div className='number-one'>
                                <p className='number-one-text'>1</p>
                            </div>
                            <div className='block-one_text'>
                                <p
                                    className='block-one_text-conditions'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('ADD_CARD_CONTACT_LESS_TEXT')
                                    }}
                                ></p>
                            </div>
                        </div>

                        <div className='conditions-action-two'>
                            <div className='number-two'>
                                <p className='number-two-text'>2</p>
                            </div>
                            <div className='block-two_text'>
                                <p
                                    className='block-two_text-conditions'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('MAKE_PURCHASE_CONTACT_LESS_TEXT2')
                                    }}
                                ></p>
                                <p
                                    className='block-two_text-conditions-mobile'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('FIVE_TRANSACTIONS_TEXT_MOBILE')
                                    }}
                                ></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='winner-block'>
                    <div className='left-part'>
                        <div className='left-img'></div>
                    </div>

                    <div className='right-part'>
                        <div className='block-info'>
                            <p className='select-winner-title'>
                                {this.l10n('CHOOSING_WINNER_TEXT')}
                            </p>
                            <p
                                className='select-winner-text'
                                dangerouslySetInnerHTML={{
                                    __html: this.l10n('CONTACT_LESS_EVERY_WEEK_TEXT')
                                }}
                            ></p>
                            <p
                                className='select-winner-text1'
                                dangerouslySetInnerHTML={{
                                    __html: this.l10n('CONTACT_LESS_FIRST_IPHONE_TEXT')
                                }}
                            ></p>
                            <p
                                className='select-winner-text2'
                                dangerouslySetInnerHTML={{
                                    __html: this.l10n('CONTACT_LESS_SECOND_IPHONE_TEXT')
                                }}
                            ></p>
                            <p
                                className='select-winner-text3'
                                dangerouslySetInnerHTML={{
                                    __html: this.l10n('CONTACT_LESS_HOLDING_ACTION_TEXT')
                                }}
                            ></p>
                        </div>
                    </div>
                </div>
                <div className='info-for-mobile'>
                    <div className='block-info'>
                        <p
                            className='winner-text'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_EVERY_WEEK_TEXT_MOBILE')
                            }}
                        ></p>
                        <p
                            className='winner-text'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_FIRST_IPHONE_TEXT_MOBILE')
                            }}
                        ></p>
                        <p
                            className='winner-text'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_SECOND_IPHONE_TEXT_MOBILE')
                            }}
                        ></p>
                        <p
                            className='winner-text'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CONTACT_LESS_HOLDING_ACTION_TEXT_MOBILE')
                            }}
                        ></p>
                    </div>
                </div>

                <div className='section files'>
                    <h2 className='section-title'>{this.l10n('CREDIT_FILES_TO_LOAD')}</h2>
                    <div className='files'>
                        <Control>
                            <div className='files-item'>
                                <Link
                                    href={
                                        this.props.lang === LANG.UA
                                            ? '/static/contact_less/promotion_rules_contact_less_ua.pdf'
                                            : '/static/contact_less/promotion_rules_contact_less_ru.pdf'
                                    }
                                    target='_blank'
                                    inText={true}
                                >
                                    <span className='document-pdf' />
                                    <span className='document-label'>
                                        {this.l10n('CONTACT_LESS_DOWNLOAD_FILE_TITLE')}
                                    </span>
                                </Link>
                            </div>
                        </Control>
                    </div>
                </div>
            </div>
        </div>
    );
}
